function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 52"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.36 24.7H10.61V13.54C10.6 6.07 16.6 0 23.99 0c7.37 0 13.37 6.07 13.37 13.54V24.7zM15.1 20.15h17.77v-6.61a8.94 8.94 0 00-8.88-8.99 8.94 8.94 0 00-8.88 8.99v6.6z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.6 52H9.37A3.4 3.4 0 016 48.59V23.56a3.4 3.4 0 013.37-3.41H38.6a3.4 3.4 0 013.37 3.41V48.6A3.4 3.4 0 0138.6 52zm-28.1-4.55h26.97V24.7H10.5v22.75z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38 24H9.78v24H38V24zM21.87 41.76h4.26c.65 0 1.14-.59 1.04-1.24l-.92-5.58.3-1.24A2.66 2.66 0 0024 30.39a2.66 2.66 0 00-2.56 3.3l.3 1.25-.91 5.58c-.1.65.39 1.24 1.04 1.24z"
})));